import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import React, { useEffect, useState } from "react";
import '../../../../cssfiles/homepage.css';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { useSelector } from 'react-redux';

const rows_asset_status_table = [
    ['AHU', '1', 'JHS713L203', 'Connected', '2024-05-27 15:04:11'],
    ['Chiller', '2', 'JHS713L204', 'Connected', '2024-05-27 15:10:40'],
    ['ETS', '3', 'JHS713L205', 'Disconnected', '2024-05-21 13:26:57'],
    ['Plating Planet', '4', 'JHS713L206', 'Connected', '2024-05-28 08:09:37'],
    ['Compressor Panel', '5', 'JHS713L207', 'Connected', '2024-05-28 08:30:45'],
    ['M.Lighting Panel', '6', 'JHS713L208', 'Connected', '2024-05-28 10:25:19'],
    ['Press Shop', '7', 'JHS713L209', 'Disconnected', '2024-05-21 19:53:05'],
]

export default function Tablewidget(props){
    //console.log("IN Tablewidget I AM IN");

    //{console.log("inside Tablewidget props.widgetprop.props.extended.",props.widgetprop.props.extended)}
    //{console.log("inside Tablewidget props.widgetprop.widgetname.",props.widgetprop.widgetname)}
    //{console.log("inside Tablewidget props.widgetprop.type.",props.widgetprop.type)}
    /*
    const rows = [
        createData('Baseline Target','9000.00' ),
        createData('Yearly Target', '8000.00'),
        createData('Yearly Consumption', '3200.00'),
        createData('This Months Target', '666.66'),
        createData('This Months Deviation', '0.00'),
        createData('Months Asking Rate', '533.00'),
        createData('Todays Consumption', '16.66'),
    ];
    function createData(  name,  value,  ) {
        return { name, value, };
    }
    */
    const filter = useSelector((state) => state.mainpagedata.filter)
    //const [assetStatusTableRows, setAssetStatusTableRows] = useState(rows_asset_status_table)
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues)
    console.log("Tablewidget insi now operate**********************tagcollectionvalue********************",tagcollectionvalue)
    const sdate_edate_selected = useSelector((state) => state.mainpagedata.selecteddates)
    const tagdetailsobject= useSelector((state) => state.mainpagedata.tagdetailsobject)
    const devicedetailsobject= useSelector((state) => state.mainpagedata.devicedetailsobject)
    var dataobject = {};
    
    //Generic variables
    const [table_head, setTableHead] = useState([]);
    const [table_rows, setTableRows] = useState([]);

    // Custom formatting function
    function formatToCustomDate(dateObj) {
        if (!dateObj || !(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
            return 'N/A';
        }
        
        const components = {
            d: dateObj.getDate(),
            m: dateObj.getMonth() + 1,
            y: dateObj.getFullYear(),
            h: dateObj.getHours(),
            min: dateObj.getMinutes(),
            s: dateObj.getSeconds()
        };
        
        const addZero = (val) => val < 10 ? `0${val}` : `${val}`;
        
        return `${addZero(components.d)}-${addZero(components.m)}-${components.y} ${addZero(components.h)}:${addZero(components.min)}:${addZero(components.s)}`;
    }

        const baseheadvalues = Array.isArray(props?.widgetprop?.props?.extended?.column_categories)
        ? props.widgetprop.props.extended.column_categories
        : [];
        var head_values = baseheadvalues.includes("Aggregation Type") && props?.widgetprop?.widgetname === 'Parameter Data'
            ? [...baseheadvalues]
            : [...baseheadvalues]; //, "Aggregation Type"

        var tagproperties = props?.widgetprop?.props?.extended?.tagprops;

    useEffect(() => { 
        
        
        var rows_values = [];
        var row_valuesOld = [];

        //console.log("head_values in tablewidget ",head_values)
        tagproperties?.map((tagprops, index)=>{
            if (tagprops && tagprops.tagname && tagprops.calculation?.calculation_operations_list) {
                var rowname = tagprops.tagname;
                var tagid = tagprops.tagid;
                var singlerowdata = [];
                var singlerowdataOld = [];
                const AggregationType = tagprops.taginformationrequired?.parameter?.calculation?.type_of_operation ? tagprops.taginformationrequired?.parameter?.calculation?.type_of_operation : 'NA';
                   
                //console.log("tagprops.calculation.calculation_operations_list in table ",tagprops.calculation.calculation_operations_list)
                for(let keyname in tagprops.calculation.calculation_operations_list){
                    
                    var currrowvalue = tagprops?.calculation?.calculation_operations_list?.[keyname]?.operand_1;
                    var currenttagid = tagprops?.taginformationrequired?.[currrowvalue]?.tagid;
                    var accessrowvalue = rowname +"."+currrowvalue;
                    console.log("in Table widget tagcollectionvalue[rowname+:+currrowvalue+:+currenttagid]",tagcollectionvalue?.[rowname+":"+currrowvalue+":"+currenttagid],"index",index,"rowname",rowname,"currrowvalue",currrowvalue,"currenttagid",currenttagid,"sdate_edate_selected",sdate_edate_selected)
                     
                    // Skip if currrowvalue is undefined or null
                    if(!currrowvalue) {
                        console.warn("Tablewidget: currrowvalue is undefined for keyname:", keyname);
                        continue;
                    }
                    
                    if(typeof tagcollectionvalue[rowname+":"+currrowvalue+":"+currenttagid] === "number"){
                        var currcellvalue=tagcollectionvalue[rowname+":"+currrowvalue+":"+currenttagid];
                        console.log("Numerical Values in Tablewidget-currcellvalue",currcellvalue)
                        singlerowdataOld.push(Number(currcellvalue).toFixed(2))
                    }else{
                        console.log("Non-Numerical Values in Tablewidget-currcellvalue",tagcollectionvalue[rowname+":"+currrowvalue+":"+currenttagid])
                        singlerowdataOld.push(tagcollectionvalue[rowname+":"+currrowvalue+":"+currenttagid])
                    }
                    if(currrowvalue === "parameter_title"){
                        const tagDetails = tagdetailsobject?.[currenttagid];
                        const deviceDetails = tagDetails?.DeviceID ? devicedetailsobject?.[tagDetails.DeviceID] : null;
                        var parameter_name = (deviceDetails?.Name || 'Unknown') + " : " + (tagDetails?.Name || 'N/A');
                        singlerowdata.push(parameter_name)
                    }else if(currrowvalue === "parameter"){
                        var currcellvalue = tagcollectionvalue?.[rowname+":"+currrowvalue+":"+currenttagid];
                        var formattedValue = (currcellvalue != null && !isNaN(currcellvalue)) ? Number(currcellvalue).toFixed(2) : 'N/A';
                        var unit = tagdetailsobject?.[currenttagid]?.Unit || '';
                        singlerowdata.push(formattedValue + (unit ? " " + unit : ''));
                    }else if(currrowvalue === "parameter_timestamp"){
                        var formattedStartDate = 'N/A';
                        var formattedEndDate = 'N/A';
                        
                        if(sdate_edate_selected?.repstartdates) {
                            try {
                                formattedStartDate = formatToCustomDate(new Date(sdate_edate_selected.repstartdates));
                            } catch(e) {
                                console.error('Error formatting start date:', e);
                            }
                        }
                        
                        if(sdate_edate_selected?.rependdates) {
                            try {
                                formattedEndDate = formatToCustomDate(new Date(sdate_edate_selected.rependdates));
                            } catch(e) {
                                console.error('Error formatting end date:', e);
                            }
                        }
                        
                        singlerowdata.push(`${formattedStartDate} - ${formattedEndDate}`);
                    }
                    
                }
                singlerowdata.push(AggregationType);
                console.log("singlerowdata in Tablewidget",singlerowdata)
                rows_values.push(singlerowdata)
                row_valuesOld.push(singlerowdataOld)
            }
            
        })

        switch(props?.widgetprop?.widgetname)
        {
            case 'Total Harmonic Details(%)':
                //console.log("head_tod_values",head_values)
                //console.log("rows_tod_values",rows_values)
                setTableHead(head_values)
                setTableRows(row_valuesOld)
                break
            case 'TOD':
                //console.log("head_tod_values TOD",head_values)
                //console.log("rows_tod_values TOD",rows_values)
                setTableHead(head_values)
                setTableRows(row_valuesOld)
                break
            case 'Energy Budgeting (kWh)':
                //console.log("head_tod_values-Energy Budgeting",head_values)
                //console.log("rows_tod_values-Energy Budgeting",rows_values)
                setTableHead(head_values)
                setTableRows(row_valuesOld)
                break
            case 'Cost Budgeting (INR)':
                setTableHead(head_values)
                setTableRows(row_valuesOld)
                break
            case 'Community Engagement':
                setTableHead(head_values)
                setTableRows(row_valuesOld)
                break
            case 'Upcoming Maintenance':
                setTableHead(head_values)
                setTableRows(rows_values)
                break
            case 'Gateway List':
                setTableHead(head_values)
                setTableRows(row_valuesOld)
                break
            case 'Asset List':
                setTableHead(head_values)
                setTableRows(row_valuesOld)
                break
            case 'Parameter Data':
                setTableHead(head_values)
                setTableRows(rows_values)
                break
           
        }
    }, [props.widgetprop, tagcollectionvalue, sdate_edate_selected]);
        
       
        // function Rows({ row_value }) {
        //     const value = row.split("\n"); 
        // }

        function BreakLine({ value }) {
            const breaklines = value.split("\n");
          
            return (
              <List sx={{padding:'4px 0px 4px 0px'}}>
                {breaklines.map((line, i) => (
                  <ListItem sx={{padding:'2px 0px 2px 0px'}} key={i}>{line}</ListItem>
                ))}
              </List>
            );
          }

          return(
            <>
            {(table_rows.length > 0 ) && ( 
                
                <TableContainer component={Paper} sx={{ width: '100%', height:"100%",paddingLeft:'0px',backgroundColor:'var(--secondary-backgroundLK)',paddingRight:'0px' }} elevation={0}>
                <Table sx={{ width: '100%' }} size="small">
                    {
                           <TableHead>
                                    <TableRow sx={{border:"0px"}}>
                                    {table_head?.map((table_head_value) => 
                                    (
                                        
                                        <TableCell sx={{
                                                        fontSize:props?.widgetprop?.props?.extended?.tablehead?.fontsize,
                                                        fontWeight:props?.widgetprop?.props?.extended?.tablehead?.fontweight,color:"var(--grey-variation-tableLK)"
                                                      }}>{table_head_value}
                                                      </TableCell>
                                    ))}
                                    </TableRow>
                                </TableHead>
                            
                        
                    }
                    {/*console.log("table_rows here",table_rows)*/}
                    <TableBody>
                        {table_rows?.map((row,index) => (
                            <TableRow
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 },height:"9px",'& > *': { borderBottom: "1px solid var(--table-boarder-line)" } }}
                            >   
                                {row?.map((row_value, row_index)=>(
                                                                                    
                                                    <TableCell component="th" scope="row" sx={{fontSize:props?.widgetprop?.props?.extended?.tablerows?.fontsize,
                                                        fontWeight:props?.widgetprop?.props?.extended?.tablerows?.fontweight,color: (row_value === 'Connected' || row_value === 'ON TARGET') ? '#00943D' : (row_value === 'Disconnected' || row_value === 'DEVIATED BY 3%') ? '#DC272D' : 'var(--grey-variation-tablerowsLK)'}} >
                                                                {/*(row_value.includes('\n'))?<BreakLine value={row_value}/>:row_value*/}
                                                                {row_value}                                                
                                                    </TableCell>        
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>)}
            </>
        )
    
}


/*
{(row_index==1 && props.widgetprop.widgetname=='TOD')?<BreakLine value={row_value}/>:row_value}


                                                        {row_value.includes('\n')?<BreakLine value={row_value}/>:row_value}

*/ 